export default __webpack_public_path__ + "37baeedfea9d0c38f2553d31a5489ce4.png";